/**
 * Spread onto inputs that must not trigger password managers / autofill.
 * `autoComplete="off"` alone is often ignored by browser extensions.
 */
export const noPasswordManagerProps = {
  autoComplete: 'off',
  autoCorrect: 'off',
  autoCapitalize: 'off',
  spellCheck: false,
  'data-1p-ignore': true,
  'data-lpignore': 'true',
  'data-bwignore': true,
  'data-form-type': 'other',
} as const;
